module.exports = __webpack_public_path__ + "img/pinBase.a69fbeaf.jpg";